import Footer from './Footer';

const MobileLayout = (props) => {
  return (
    <div className="flex flex-col w-full h-screen">
      {props.children}
      <Footer />
    </div>
  );
};

export default MobileLayout;
